import { clashNeutral, clashTopic } from '@/mocks/homeData';
import SectionHead from './SectionHead';

export default function OpinionClash() {
  const { left, right } = clashTopic;

  return (
    <section id="clash" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <SectionHead
          zone="分区 03"
          title="观点对撞"
          desc="同一个话题，两种主流态度并排放置。不评判，只呈现，比例来自公开讨论中的声量统计。"
        />

        <div className="mt-7 rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <h4 className="font-heading text-lg font-black text-foreground-950 md:text-xl">
              当前争议：{clashTopic.topic}
            </h4>
            <span className="font-label text-xs text-foreground-500">{clashTopic.heatLine}</span>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
            {[left, right].map((side, idx) => (
              <div
                key={side.camp}
                className={`rounded-lg border-t-4 bg-background-50 p-5 ${
                  idx === 0 ? 'border-primary-500' : 'border-secondary-500'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`rounded-sm px-2 py-0.5 font-label text-[11px] font-bold ${
                      idx === 0
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-900'
                    }`}
                  >
                    {idx === 0 ? '立场 A' : '立场 B'}
                  </span>
                  <span
                    className={`font-heading text-xl font-black ${
                      idx === 0 ? 'text-primary-600' : 'text-secondary-600'
                    }`}
                  >
                    {side.ratio}%
                  </span>
                </div>
                <h5 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {side.camp}
                </h5>
                <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{side.stance}</p>
                <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`grow-bar h-full rounded-full ${idx === 0 ? 'bg-primary-500' : 'bg-secondary-500'}`}
                    style={{ width: `${side.ratio}%` }}
                  ></div>
                </div>
                <ul className="mt-4 flex flex-col gap-2">
                  {side.points.map((point) => (
                    <li key={point} className="flex items-start gap-2 font-label text-xs text-foreground-700 md:text-sm">
                      <i
                        className={`mt-0.5 ${idx === 0 ? 'ri-add-line text-primary-500' : 'ri-add-line text-secondary-500'}`}
                        aria-hidden="true"
                      ></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* 中立观望 */}
          <div className="mt-4 flex flex-col gap-3 rounded-lg border border-dashed border-accent-400 bg-accent-50 p-4 md:flex-row md:items-center md:gap-5">
            <div className="flex shrink-0 items-center gap-2">
              <i className="ri-scales-3-line text-lg text-accent-700" aria-hidden="true"></i>
              <span className="font-heading text-sm font-bold text-accent-900">{clashNeutral.camp}</span>
            </div>
            <p className="flex-1 font-body text-xs text-foreground-700 md:text-sm">{clashNeutral.stance}</p>
            <span className="shrink-0 font-heading text-xl font-black text-accent-700">{clashNeutral.ratio}%</span>
          </div>
        </div>
      </div>
    </section>
  );
}